// ! The commands as in order and should not be changed

/**
 * It takes in a command, a parameter, a player array, an interval array, a video id, a search result
 * array, a socket, and a search result array. It then checks if the command is a valid command. If it
 * is, it will execute the command
 * @param command - the command that the user typed in the chat
 * @param param - the parameter that is passed in from the chat
 * @param player - an array of youtube players
 * @param setInter - the setInterval function
 * @param inter - the array that stores the setInterval id for each player
 * @param videoId - the id of the video that is currently playing
 * @param setSearchResult - a function that sets the searchResult state
 * @param socket - the socket object
 * @param searchResult - the array of search results
 * @returns the function onPlayerCommand.
 */
export const onPlayerCommand = (
  command,
  param,
  player,
  setInter,
  inter,
  videoId,
  setSearchResult,
  socket,
  searchResult
) => {
  /**
   * It takes in a video object, a start time, an interval, and a boolean. It then creates a new
   * interval that checks if the video is playing, and if it isn't, it plays it. It then seeks to the
   * start time
   * managing each player setInterval command : this function is only called when loopAt is called on any player
   * this function is to manage the loopAt state of each player
   * @param video - the video object
   * @param startLoop - the time in seconds where the video should loop
   * @param interval - the interval at which the video will loop
   * @param clear - boolean,
   */
  const intercommand = (video, startLoop, interval, clear) => {
    /* Checking if the video is playing, and if it isn't, it plays it. It then seeks to the start time */
    const newInter = setInterval(() => {
      if (video.getPlayerState() !== 1) {
        video.playVideo();
      }

      video.seekTo(startLoop, true);
      console.log('loopAt');
    }, interval);

    /* Storing the setInterval id for each play */
    setInter(inter.push({ inter: newInter, playerNum: param.playerNum }));
  };

  /* Checking if the command is a valid command. */
  if (command.length < 4) {
    return;
  }

  // this is used for the select command and it is intentionally put out of the other commands
  /* A function that is called when the user types in the command "select" in the chat. It is used to
  select a video from the search results. */
  if (command === 'select') {
    if (param !== null) {
      const num = Number(param.playerNum);
      if (searchResult.length > 0) {
        try {
          /* Assigning the value of the video id to the variable id. */
          const id = searchResult[num].id.videoId;

          /* Sending a command to the server to set the video id to the id of the video that was
          clicked. */
          socket.emit('sendCommand', {
            command: 'setVideoId',
            param: id,
          });
          setSearchResult([]);
        } catch (error) {
          console.log(error);
        }
      }
    }
  }

  /* Checking if the player array has a length greater than 0. If it does, it filters the player array
  to find the playerNum that matches the playerNum in the param object. */
  if (player.length !== 0) {
    // filter the null players that automatically generates itself
    /* The below code is filtering out the players that have a null value for the o, u, m, and A
    properties. */
    /* The below code is filtering out the null players that automatically generates itself. */
    let play = player.filter((player) => {
      return player.o !== null;
    });

    play = play.filter((player) => {
      return player.u !== null;
    });

    play = play.filter((player) => {
      return player.m !== null;
    });

    play = play.filter((player) => {
      return player.A !== false;
    });

    /* The below code is trying to play a video on a youtube player. */
    if (command === 'play') {
      if (param !== null && param.playerNum >= 0) {
        /* The above code is checking if the inter array has a length greater than 0. If it does, it
       filters the inter array to find the playerNum that matches the playerNum in the param object.
       If the player is currently in loop, and if it is, it stops the loop. */
        if (inter.length > 0) {
          /* Filtering the inter array to find the playerNum that matches the playerNum in the param
          object. */
          const stopInter = inter.filter((inter) => {
            return inter.playerNum === param.playerNum;
          });

          /* Checking if the player is currently in loop, and if it is, it stops the loop. */
          if (stopInter.length > 0) {
            stopInter.forEach((i) => {
              clearInterval(i.inter);
            });
          }
        }

        const num = Number(param.playerNum);

        /* The above code is trying to play a video on a youtube player. */
        setTimeout(() => {
          // console.log(play);
          // console.log(videoId);
          try {
            play[num].playVideo();
            play[num].unMute();
          } catch (e) {
            console.log(e, 'error');
          }
        }, 3000);

        return;
      }
      // play all video
      return play.forEach((player) => {
        // check if any player is currently in
        // then stop all loop
        /* Clearing the interval. */
        if (inter.length > 0) {
          inter.forEach((inter) => {
            clearInterval(inter.inter);
          });
        }

        /* Trying to play the video and unmute it. */
        try {
          player.playVideo();
          player.unMute();
        } catch (e) {
          console.log(e, 'error');
        }
      });
    }

    /* The Below code is pausing the video. */
    if (command === 'pause') {
      if (param !== null && param.playerNum >= 0) {
        /* The below code is checking if the player is currently in loop. If the player is in loop,
        then stop the loop. */
        if (inter.length > 0) {
          // check if the player is currently in loop
          const stopInter = inter.filter((inter) => {
            return inter.playerNum === param.playerNum;
          });

          // then stop the loop
          /* The below code is clearing the interval. */
          if (stopInter.length > 0) {
            stopInter.forEach((i) => {
              clearInterval(i.inter);
            });
          }
        }

        /* Pausing the video. */
        try {
          play[Number(param.playerNum)].pauseVideo();
        } catch (error) {
          console.log(error);
        }
        return;
      }
      // pause all video
      return play.forEach((player) => {
        // console.log(player);
        // check if any player is currently in loop and stop it
        if (inter.length > 0) {
          inter.forEach((inter) => {
            clearInterval(inter.inter);
          });
        }

        try {
          player.pauseVideo();
        } catch (e) {
          console.log(e, 'error');
        }
      });
    }

    /* The below code is trying to play the video and seek to the startLoop. If it fails, it will log
   the error. */
    if (command === 'loopAt') {
      if (param !== null && param.playerNum >= 0) {
        const video = play[Number(param.playerNum)];

        // converting the start and end seconds into number
        const startLoop = Number(param.param.startLoop);
        const endLoop = Number(param.param.endLoop);

        // creating the loop interval
        const interval = endLoop * 1000 - startLoop * 1000;

        /* The below code is trying to play the video and seek to the startLoop. If it fails, it will
       log the error. */
        try {
          video.playVideo();
          video.seekTo(startLoop, true);
          // starting the loop
          intercommand(video, startLoop, interval);
        } catch (error) {
          console.log(error);
        }

        return;
      }

      return;
    }

    /* Muting the video. */
    if (command === 'mute') {
      /* Checking if the parameter is not null and if the playerNum is greater than or equal to 0. */
      if (param !== null && param.playerNum >= 0) {
        /* Muting the player. */
        try {
          play[Number(param.playerNum)].mute();
        } catch (error) {
          console.log(error);
        }
        return;
      }
      /* The below code is muting all the videos on the page. */
      return play.forEach((player) => {
        // console.log(player);
        try {
          player.mute();
        } catch (e) {
          console.log(e, 'error');
        }
      });
    }

    /* The below code is unmuting the video. */
    if (command === 'unmute') {
      /* Unmuting the video. */
      /* Checking if the parameter is not null and if the playerNum is greater than or equal to 0. */
      if (param !== null && param.playerNum >= 0) {
        /* Unmuting the player. */
        try {
          play[Number(param.playerNum)].unMute();
        } catch (error) {
          console.log(error);
        }
        return;
      }
      /* Unmuting all the players in the array. */
      return play.forEach((player) => {
        // console.log(player);
        try {
          player.unMute();
        } catch (e) {
          console.log(e, 'error');
        }
      });
    }

    /* The below code is stopping the video. */
    if (command === 'stop') {
      /* Checking if the param is not null and if the playerNum is greater than or equal to 0. */
      if (param !== null && param.playerNum >= 0) {
        /* Checking if the inter array has a length greater than 0. If it does, it filters the inter array
     to find the playerNum that matches the playerNum in the param object. If the player is
     currently in loop, and if it is, it stops the loop. */
        if (inter.length > 0) {
          // check if the player is currently in loop
          /* Filtering the inter array to find the playerNum that matches the playerNum in the param
         object. */
          const stopInter = inter.filter((inter) => {
            return inter.playerNum === param.playerNum;
          });

          /* Clearing the interval. */
          if (stopInter.length > 0) {
            stopInter.forEach((i) => {
              clearInterval(i.inter);
            });
          }
        }

        /* Stopping the video. */
        try {
          play[Number(param.playerNum)].stopVideo();
        } catch (error) {
          console.log(error);
        }

        return;
      }
      /* Stopping the video. */
      return play.forEach((player) => {
        /* Clearing the interval. */
        if (inter.length > 0) {
          inter.forEach((inter) => {
            clearInterval(inter.inter);
          });
        }

        /* Stopping the video. */
        try {
          player.stopVideo();
        } catch (e) {
          console.log(e, 'error');
        }
      });
    }

    /* The below code is seeking to a specific time in the video. */
    if (command === 'seek') {
      /* Checking if the parameter is not null and if the playerNum is greater than or equal to 0. */
      if (param !== null && param.playerNum >= 0) {
        /* Checking to see if the length of the array is greater than 0. */
        if (inter.length > 0) {
          // check if the player is currently in loop
          /* Filtering the inter array to find the playerNum that matches the playerNum in the param
          object. */
          const stopInter = inter.filter((inter) => {
            return inter.playerNum === param.playerNum;
          });

          /* Clearing the interval. */
          if (stopInter.length > 0) {
            stopInter.forEach((i) => {
              clearInterval(i.inter);
            });
          }
        }

        /* Seeking to a specific time in the video. */
        try {
          play[Number(param.playerNum)].seekTo(Number(param.param), true);
        } catch (error) {
          console.log(error);
        }

        return;
      }
      /* The below code is clearing the interval and seeking to a specific time in the video. */
      return play.forEach((player) => {
        /* The below code is clearing the interval. */
        if (inter.length > 0) {
          // check if the player is currently in loop
          inter.forEach((inter) => {
            clearInterval(inter.inter);
          });
        }

        /* Seeking to a specific time in the video. */
        try {
          player.seekTo(param.param, true);
        } catch (e) {
          console.log(e, 'error');
        }
      });
    }

    /* The below code is setting the playback rate of the video. */
    if (command === 'delay') {
      /* Checking if the parameter is not null and if the playerNum is greater than or equal to 0. */
      if (param !== null && param.playerNum >= 0) {
        /* Setting the playback rate of the video. */
        try {
          // console.log(typeof param.param);
          play[Number(param.playerNum)].setPlaybackRate(Number(param.param));
        } catch (error) {
          console.log(error);
        }
        return;
      }
      return play.forEach((player) => {
        /* Setting the playback rate of the video to the value of the parameter. */
        try {
          player.setPlaybackRate(Number(param.param));
        } catch (e) {
          console.log(e, 'error');
        }
      });
    }

    /* The below code is setting the volume of the audio file. */
    if (command === 'fade') {
      /* Checking if the parameter is not null and if the playerNum is greater than or equal to 0. */
      if (param !== null && param.playerNum >= 0) {
        const num = Number(param.playerNum);

        /* Setting the volume of the audio file. */
        try {
          play[num].setVolume(param.param);
        } catch (error) {
          console.log(error);
        }
        return;
      }
      /* Setting the volume of the player to the value of the parameter. */
      return play.forEach((player) => {
        /* Setting the volume of the player to the value of the parameter. */
        try {
          player.setVolume(param.param);
        } catch (e) {
          console.log(e, 'error');
        }
      });
    }
  }
};
